import request from '../axiosInterceptor'

const api = {
  getVideoScriptGenerationList() {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/video-script-generation/list`,
      method: 'get',
    })
  },
}

export default api
